module.exports = __webpack_public_path__ + "img/守护助手.631f5601.png";